import $ from 'jquery';

import { Stores } from './stores/Stores';
import * as LocationStore from './stores/location-store';

import { SceneManager } from './components/threes/SceneManager';
import { InfoPanel } from './components/ui/infoPanel/InfoPanel';
import { MenuPanel } from './components/ui/MenuPanel';
import { StaffPanel } from './components/ui/StaffPanel';
import { LanguageMenu } from './components/ui/LanguageMenu';
import * as Message from './components/message';

import { getMenus, getContents, getMessages, getVideos } from './middleware/api-middleware';

require('./../styles/fonts.scss');
require('./../styles/styles.scss');

let stores = null,
    sceneManager = null,
    view = null,
    menuPanel = null,
    infoPanel = null;

let startX = null, startY = null,
    diffX = null, diffY = null,
    startTouchDistance = null;

function onDocumentTouchStart( event ) {
    if ( event.touches.length === 1 ) {
        event.preventDefault();

        sceneManager.isTouching = true;

        startX = event.clientX = event.touches[0].pageX;
        startY = event.clientY = event.touches[0].pageY;

        sceneManager.onMarkerPress(event);

        view.addEventListener('touchmove', onDocumentTouchMove, false);
        document.addEventListener('touchend', onDocumentTouchEnd, false);

    }else if ( event.touches.length === 2) {
        event.preventDefault();

        sceneManager.isTouching = true;
        const disX = event.touches[0].pageX - event.touches[1].pageX;
        const disY = event.touches[0].pageY - event.touches[1].pageY;

        startTouchDistance = Math.sqrt(disX * disX + disY * disY);
    }
}

function onDocumentTouchMove( event ) {
    if ( event.touches.length === 1 ) {
        event.preventDefault();

        diffX = startX - event.touches[0].pageX;
        diffY = startY - event.touches[0].pageY;
        sceneManager.setMoveDiff(diffX, diffY);

        onDragBackground(event.touches[0].pageX, event.touches[0].pageY);

        startX = event.touches[0].pageX;
        startY = event.touches[0].pageY;

    }else if ( event.touches.length === 2) {
        event.preventDefault();

        const disX = event.touches[0].pageX - event.touches[1].pageX;
        const disY = event.touches[0].pageY - event.touches[1].pageY;

        let direction = '';
        const dist = Math.sqrt(disX * disX + disY * disY);

        if(startTouchDistance > dist) {
            direction = 'contracting';
        }else {
            direction = 'expanding';
        }

        if(Math.abs(startTouchDistance - dist) < 5 ) {
            return;
        }

        startTouchDistance = dist;
        sceneManager.touchZoom(dist, direction);
    }
}

function onDocumentTouchEnd() {
    view.removeEventListener('touchmove', onDocumentTouchMove, false);
    document.removeEventListener('touchend', onDocumentTouchEnd, false);
}

function onDocumentMouseDown(event) {
    event.preventDefault();

    sceneManager.isTouching = true;

    startX = event.pageX;
    startY = event.pageY;

    sceneManager.onMarkerPress(event);

    view.addEventListener( 'mousemove', onDocumentMouseMove, false );
    document.addEventListener( 'mouseup', onDocumentMouseUp, false );
}

function onDocumentMouseMove(event) {
    diffX = startX - event.pageX;
    diffY = startY - event.pageY;
    sceneManager.setMoveDiff(diffX, diffY);

    onDragBackground(event.pageX, event.pageY);

    startX = event.pageX;
    startY = event.pageY;
}

function onDocumentMouseUp() {
    view.removeEventListener( 'mousemove', onDocumentMouseMove, false );
    document.removeEventListener( 'mouseup', onDocumentMouseUp, false );
}

function init() {
    /**
     * Important. Otherwise markers will not be rendered if not create unique canvas for markers
     */
    view = document.getElementById('globe');
    createCanvasForMarkers();

    // initLanguageMenu();
    initScene();
    initInfoPanel();
    initMenuPanel();
    new StaffPanel();

    setTimeout( () => {
        Message.initMesssage();
    }, 2000);

    if(TOUCH_SCREEN) {
        view.addEventListener('touchstart', onDocumentTouchStart, false);
    } else {
        view.addEventListener('mousedown', onDocumentMouseDown, false);
    }

    window.addEventListener('resize', onWindowResize, false );
    // openFullscreen();
}

function initLanguageMenu() {
    new LanguageMenu().on('onChangeLanguage', () => {
        infoPanel.updateContents();
        Message.updateContents();
        menuPanel.updateContents();
    });
}

function initScene() {
    sceneManager = new SceneManager(view);
    sceneManager.on('onMarkerClick', (marker) => {
        Message.msgSlideOut();
        menuPanel.slideOut();
        if(marker.hasSiblings) {
            infoPanel.openMenu(marker.siblings);
        }else {
            infoPanel.open(marker.markerId);
        }

        //stop spin because of showing video
        setTimeout( () => {
            sceneManager.isActive = false;
        }, 2000);
    });
}

function initInfoPanel() {
    infoPanel = new InfoPanel();
    infoPanel.on('onCloseInfoPanel', () => {
        Message.msgSlideIn();
        //resume
        sceneManager.active();
        sceneManager.cameraZoomOut();
        menuPanel.slideIn();
    });
}

function initMenuPanel() {
    menuPanel = new MenuPanel();
    menuPanel.on('onClickSubMenuItem', (contentId) => {
        Message.msgSlideOut();
        infoPanel.open(contentId);
        sceneManager.zoom.scaleUp();

        //stop spin because of showing video
        setTimeout( () => {
            sceneManager.isActive = false;
        }, 2000);

    });
}

function onload() {
    console.log("GLOBAL VARIABLE - NODE_ENV:",process.env.NODE_ENV);
    console.log("GLOBAL VARIABLE - TOUCH_SCREEN:",TOUCH_SCREEN);
    console.log("GLOBAL VARIABLE - HIGH_RES:",HIGH_RES);
    stores = new Stores();
    Promise.all([getContents(), getMenus(), getMessages()]).then(function(values) {
        const contents = values[0];
        const menus = values[1];
        const coverMessages = values[2];
        // const videos = values[3];

        if(contents.length > 0) {
            stores.setContents(contents);
            stores.setLocations(contents);
        }

        if(menus.length > 0) stores.setMenus(menus);
        if(coverMessages.length > 0) stores.setMessages(coverMessages);
        // if(videos.length > 0) stores.setVideos(videos);

        setTimeout( () => {
            init();
        }, 500);

    }).catch( (error) => {
        alert('Fail to get data :' + error + ', it will fall back to the globe.json');
        loadJson();
    });
}

function onWindowResize() {
    sceneManager.resizeScene();
}

/**
 * Put `<canvas class="marker" data-id="0" id="marker-{id}" width="128" height="128"></canvas>...` to the dom for canvas texture
 * If more than one content in one place, use the first one for marker
 */
function createCanvasForMarkers() {
    const places = LocationStore.get();
    for(let name in places) {
        const place = places[name][0];
        const contentId = place.contentId;
        const dom = `<canvas class="marker" id="marker-${contentId}" width="128" height="128"></canvas>`;
        $('body').append(dom);
    }
}

function onDragBackground(mouseX, mouseY) {
    /**
     * movableRatio = backround's width - 100%;
     * buffer - 2
     */
    const dragBuffer = 1;
    const movableRatio = 10 - dragBuffer;
    mouseX -= window.innerWidth / 2; // eslint-disable-line no-param-reassign
    mouseY -= window.innerHeight / 2; // eslint-disable-line no-param-reassign

    const bgMoveX = mouseX * (movableRatio / window.innerWidth);
    const bgMoveY = mouseY * (movableRatio / window.innerHeight);

    const upperBound = -50 + (movableRatio / 2);
    const lowerBound = -50 - (movableRatio / 2);

    let bgTranslateX = -50 + bgMoveX;
    let bgTranslateY = -50 + bgMoveY;

    if(bgTranslateX > upperBound) {
        bgTranslateX = upperBound;
    }

    if(bgTranslateX < lowerBound) {
        bgTranslateX = lowerBound;
    }

    if(bgTranslateY > upperBound) {
        bgTranslateY = upperBound;
    }

    if(bgTranslateY < lowerBound) {
        bgTranslateY = lowerBound;
    }

    $('.background').css('transform', `translate3d(${bgTranslateX}%, ${bgTranslateY}%, 0)`);
}

function openFullscreen() {
    const btn = document.querySelector('#fullscreenButton');
    btn.addEventListener('click', () => {
        const element = document.documentElement,
            rfs = element.requestFullscreen ||
                element.webkitRequestFullScreen ||
                element.mozRequestFullScreen ||
                element.msRequestFullscreen;

        rfs.call(element);
        btn.style.display = 'none';
        // document.body.style.cursor = 'none';
    });
}

function loadJson() {
    const options = {
        type: 'GET',
        url: './../globe.json'
    };
    $.ajax(options).done((data) => {
        setTimeout( () => {
            init();
        }, 500);
    }).fail((err) =>  {
        console.log(err);
    });
}

window.addEventListener('load', onload);
